import { Input, InputProps } from "antd";

const NumericStringInput = (
  props: Omit<InputProps, "onChange"> & { onChange?: (value: string) => void }
) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value.replace(/[^0-9]/g, "");
    props.onChange?.(inputValue);
  };
  return <Input {...props} onChange={onInputChange} />;
};

export default NumericStringInput;
